<div [hidden]="title==''" class="modal-header justify-content-start align-items-center py-0">
  <i class="mdi {{iconClass}} f-60 py-2 mr-2"></i>
  <h2 class="py-3">{{title}}</h2>
</div>

<div [hidden]="text=='' || html" class="modal-body">
  {{text}}
</div>

<div [hidden]="text=='' || !html" [innerHTML]="text" class="modal-body">
  {{text}}
</div>

<div class="modal-footer d-flex justify-content-between">
  <div [hidden]="!ok.hidden"></div>
  <button [ngClass]="{'mr-md-5 mr-2': !ok.hidden}" [hidden]="cancel.hidden" class="btn {{cancel.btnClass}} w-50  mr-md-5 mr-2" (click)="activeModal.close('cancel')">
    {{cancel.text}}
  </button>
  <div [hidden]="!cancel.hidden"></div>
  <button [hidden]="ok.hidden" class="btn {{ok.btnClass}} w-50 ml-md-5 ml-2" (click)="activeModal.close('ok')">
    {{ok.text}}
  </button>
</div>
